import { headerCommonProps } from "./commonHeaderProps";

const sticky = {
  props: {
    className: "c-header",
    classNameSticky: "mod--sticky-header",
    classNameHideOthersSticky: "mod--hide-others-sticky",
    classNameShowOthersSticky: "mod--show-others-sticky",
    classNameStickyHeader: "mod--sticky-header-top",
    classNameHideSticky: "mod--hide-header-sticky",
    active: false,
    lastScrollY: 0,
  },

  init: function () {
    const $component = headerCommonProps.$container.getElementsByClassName(this.props.className);

    if (!$component || !$component[0]) {
      return;
    }

    this.props.$container = $component[0];

    window.addEventListener("scroll", this.windowScrollEvent.bind(this), false);

    this.resize();
  },

  resize: function () {
    if (bcl.editMode) {
      return;
    }

    const isMobile = bcl.u.mobile.isMobile();

    if (isMobile && !this.props.active) {
      this.enable();
      return;
    }

    if (!isMobile && this.props.active) {
      this.disable();
    }
  },

  enable: function () {
    this.props.active = true;
  },

  disable: function () {
    this.props.active = false;

    this.hide();
  },

  windowScrollEvent: function () {
    if (!this.props.active || bcl.editMode) {
      return;
    }

    this.props.direction = this.props.lastScrollY <= (window.scrollY || document.documentElement.scrollTop) ? 1 : -1;

    this.props.lastScrollY = window.scrollY || document.documentElement.scrollTop;

    if (this.props.direction === -1) {
      const value = bcl.s.sticky.getScrollTop(this.props.$container.parentNode),
        result = bcl.s.sticky.stickyGeneral({ $node: this.props.$container }, value + 1, this.props.classNameStickyHeader),
        status = result > 0;

      if (status && !this.props.startScrollY) {
        this.show();
      } else if (status && this.props.endScrollY && this.props.endScrollY >= this.props.lastScrollY) {
        this.hideOthersSticky();
        this.props.endScrollY = null;
      } else if (!status) {
        this.hide();
      }
    } else {
      this.hide();
    }
  },

  show: function () {
    this.props.timeout && clearTimeout(this.props.timeout);

    this.props.startScrollY = this.props.lastScrollY;
    this.props.endScrollY = this.props.startScrollY - window.innerHeight * 2;

    if (this.props.endScrollY < 0) {
      this.props.endScrollY = 1;
    }

    bcl.u.addClass(document.body, this.props.classNameSticky);
    bcl.u.removeClass(this.props.$container, this.props.classNameHideSticky);
  },

  hideOthersSticky: function () {
    bcl.u.addClass(document.body, this.props.classNameHideOthersSticky);
    this.props.endScrollY = null;
  },

  hide: function () {
    if (!this.props.startScrollY) {
      return;
    }

    bcl.u.addClass(this.props.$container, this.props.classNameHideSticky);
    bcl.u.addClass(document.body, this.props.classNameShowOthersSticky);
    bcl.u.removeClass(document.body, this.props.classNameSticky);
    this.props.timeout = setTimeout(() => {
      bcl.u.removeClass(document.body, this.props.classNameHideOthersSticky);
      bcl.u.removeClass(document.body, this.props.classNameShowOthersSticky);

      bcl.u.removeClass(this.props.$container, this.props.classNameStickyHeader);
      bcl.u.removeClass(this.props.$container, this.props.classNameHideSticky);
    }, 500);

    this.props.startScrollY = null;
    this.props.endScrollY = null;
  },
};

export default sticky;
